// import {
// } from 'constants/ActionTypes';

export default function builder(state = {}, action) {
  switch (action.type) {
    default:
      return state;
  }
}
